// extracted by mini-css-extract-plugin
export default {"section":"Pausenspielraum_section__c4N10","text":"Pausenspielraum_text__Ttaw2","image":"Pausenspielraum_image__6eT76"};